<script lang="ts" setup>
interface Props {
  title: string
  size?: 'small' | 'medium' | 'large'
  tag?: 'h1' | 'h2' | 'h3'
}

defineProps<Props>()
</script>

<template>
  <component
    :is="tag ?? 'h3'"
    :class="{
      'text-3xl md:text-5xl': !size,
      'text-2xl': size === 'small',
      'text-3xl': size === 'medium',
      'text-4xl': size === 'large',
    }"
    class="font-bold font-adieu"
  >
    {{ title }}
  </component>
</template>
